import { render } from "./scenario-participant-feedback.vue?vue&type=template&id=6472ce68&scoped=true&ts=true"
import script from "./scenario-participant-feedback.vue?vue&type=script&lang=ts"
export * from "./scenario-participant-feedback.vue?vue&type=script&lang=ts"

import "./scenario-participant-feedback.vue?vue&type=style&index=0&id=6472ce68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6472ce68"]])

export default __exports__